import {
    DateInput,
    required,
    useCreate,
    useGetList,
    useNotify,
    useRedirect,
} from 'react-admin';
import { useSearchParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { GenerateForm } from '@components/GenerateForm';
import { entityResource as ent } from '@src/entityResource';
import { dataObject } from '@src/object.type';

export const GenerateSchedule = () => {
    const [q] = useSearchParams();
    const [create] = useCreate();
    const redirect = useRedirect();
    const notify = useNotify();

    const { data: stores } = useGetList(ent.STORE.NAME, {
        pagination: { page: 1, perPage: Number(q.get('total')) || 25 },
    });

    const onGenerate = (data: dataObject) => {
        const startDate = new Date(data.startDate);
        const endDate = new Date(data.endDate);

        if (startDate > endDate || !stores) {
            notify(
                'Rentang tanggal tidak valid atau tidak ada data toko ditemukan',
                { type: 'error' }
            );
            return;
        }

        const newSchedule: {
            userId: string;
            storeId: string;
            visitDate: string;
        }[] = [];
        while (startDate <= endDate) {
            const day = startDate.getDay();
            const s = stores.filter(s => String(s.visitDay) === String(day));

            if (s.length) {
                s.map(store => {
                    newSchedule.push({
                        userId: store.userId,
                        storeId: store.id,
                        visitDate: startDate.toDateString(),
                    });
                });
            }

            startDate.setDate(startDate.getDate() + 1);
        }

        create(
            ent.SCHEDULE.BULK,
            { data: newSchedule },
            {
                onSuccess: () => {
                    redirect('list', ent.SCHEDULE.NAME);
                    notify('resources.schedule.event.generateSuccess', {
                        type: 'success',
                    });
                },
                onError: () => {
                    notify('resources.schedule.event.generateSuccess', {
                        type: 'error',
                    });
                },
            }
        );
    };

    return (
        <GenerateForm onSubmit={onGenerate} resource={ent.SCHEDULE.NAME}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <DateInput source="startDate" validate={[required()]} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <DateInput source="endDate" validate={[required()]} />
                </Grid>
            </Grid>
        </GenerateForm>
    );
};
